export default __webpack_public_path__ + "static/flowers-left-897c02a733db3a7e37df4ca75f39ff2c.png";